import { useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { LoadingStateType } from 'reducers/loadings';

const useLoadings = (): LoadingStateType => {
  return useSelector((state: RootState) => state.loadings);
};

export default useLoadings;
